/* Claims module — sample data + rules ported from the prototype. */

export const CLAIMS = [
  {
    id: "CL-2026-091",
    type: "Cash Claim",
    title: "Staff welfare and medical claim",
    desc: "Gym membership, dental filling and mileage attachment",
    period: "November 2026",
    code: "BE-OPS-001",
    amount: "7,992.00",
    status: "Pending Approval",
  },
  {
    id: "CL-2026-083",
    type: "Local Travel Claim",
    title: "Within Malaysia travel expenses",
    desc: "Travel expenses with meal allowance attachment",
    period: "09 Nov - 17 Nov 2026",
    code: "BE-MKT-001",
    amount: "288.00",
    status: "Approved",
  },
  {
    id: "CL-2026-076",
    type: "Mileage Claim",
    title: "Vehicle mileage reimbursement",
    desc: "Home, airport and event venue routes",
    period: "November 2026",
    code: "BE-OPS-001",
    amount: "5,994.00",
    status: "Paid",
  },
  {
    id: "CL-2026-058",
    type: "Credit Card Claim",
    title: "Monthly corporate card expenses",
    desc: "Submitted by end of month",
    period: "October 2026",
    code: "BE-FIN-001",
    amount: "1,480.00",
    status: "Draft",
  },
  {
    id: "CL-2026-041",
    type: "Overseas Travel Claim",
    title: "Overseas travel expense with exchange rate",
    desc: "Origin currency receipt converted to RM",
    period: "August 2026",
    code: "BE-EVT-001",
    amount: "4,250.00",
    status: "Returned",
  },
];

export const GENERATED_CARD_CLAIMS_KEY = "besarawak_generated_card_claims_v1";

export const getClaims = () => {
  try {
    const generated = JSON.parse(window.localStorage.getItem(GENERATED_CARD_CLAIMS_KEY));
    return Array.isArray(generated) ? [...generated, ...CLAIMS] : CLAIMS;
  } catch (error) {
    return CLAIMS;
  }
};

export const getClaimStatus = (id) => {
  const row = getClaims().find((claim) => claim.id === id);
  return row ? row.status : "Pending Approval";
};

export const STATUS_BADGE_CLASS = {
  "Pending Approval": "status-pending",
  Approved: "claim-status-approved",
  Paid: "claim-status-paid",
  Draft: "claim-status-draft",
  Returned: "claim-status-rejected",
  Rejected: "claim-status-rejected",
};

/* Status banner content per claim status (detail page). */
export const CLAIM_BANNERS = {
  "Pending Approval": {
    cls: "",
    icon: "ri-time-line",
    title: "Pending Head of Unit Approval",
    text: "This claim has been submitted and is currently awaiting review by the employee's Head of Unit.",
  },
  Approved: {
    cls: "banner-approved",
    icon: "ri-checkbox-circle-fill",
    title: "Approved — Awaiting Payment",
    text: "Supervisor and HR have approved this claim. Finance is processing the payment.",
  },
  Paid: {
    cls: "banner-paid",
    icon: "ri-money-dollar-circle-fill",
    title: "Paid",
    text: "Payment was completed on 30 Jul 2026 to the registered bank account.",
  },
  Draft: {
    cls: "banner-draft",
    icon: "ri-file-list-2-line",
    title: "Draft — Not Submitted",
    text: "This claim is still a draft. Complete the details and submit it for approval.",
  },
  Returned: {
    cls: "banner-rejected",
    icon: "ri-error-warning-fill",
    title: "Returned for Correction",
    text: 'Head of Unit: "Dental amount does not match the attached invoice, and the mileage form is missing a signature." Amend and resubmit.',
  },
};

/* Approval flow: Employee -> Head of Unit -> Head of Department -> Finance.
   dot: 'check' | 'cross' | a step number rendered inside the circle. */
export const buildClaimTimeline = (status) => {
  const submittedDone = {
    state: "done",
    dot: "check",
    title: "Submitted by Employee",
    meta: "Eldren Aniell Dunggat · 20 Jul 2026, 10:35 AM",
  };
  const flows = {
    Draft: [
      { state: "current", dot: "1", title: "Submitted by Employee", meta: "Not yet submitted" },
      { state: "", dot: "2", title: "Head of Unit", meta: "Starts after submission" },
      { state: "", dot: "3", title: "Head of Department", meta: "Starts after Head of Unit approval" },
      { state: "", dot: "4", title: "Finance Review", meta: "Final approval and payment processing" },
    ],
    "Pending Approval": [
      submittedDone,
      { state: "current", dot: "2", title: "Head of Unit", meta: "Pending review by Denny Tan Yee Soon" },
      { state: "", dot: "3", title: "Head of Department", meta: "Starts after Head of Unit approval" },
      { state: "", dot: "4", title: "Finance Review", meta: "Final approval and payment processing" },
    ],
    Returned: [
      submittedDone,
      { state: "rejected", dot: "cross", title: "Returned by Head of Unit", meta: "Denny Tan Yee Soon · 21 Jul 2026, 9:12 AM — see reason above" },
      { state: "", dot: "3", title: "Head of Department", meta: "Not started — claim was returned" },
      { state: "", dot: "4", title: "Finance Review", meta: "Not started" },
    ],
    Approved: [
      submittedDone,
      { state: "done", dot: "check", title: "Head of Unit Approved", meta: "Denny Tan Yee Soon · 21 Jul 2026, 2:20 PM" },
      { state: "done", dot: "check", title: "Head of Department Approved", meta: "Andrea Kahar · 22 Jul 2026, 11:05 AM" },
      { state: "current", dot: "4", title: "Finance Review", meta: "Processing payment" },
    ],
    Paid: [
      submittedDone,
      { state: "done", dot: "check", title: "Head of Unit Approved", meta: "Denny Tan Yee Soon · 21 Jul 2026, 2:20 PM" },
      { state: "done", dot: "check", title: "Head of Department Approved", meta: "Andrea Kahar · 22 Jul 2026, 11:05 AM" },
      { state: "done", dot: "check", title: "Paid by Finance", meta: "30 Jul 2026 · RM 7,992.00 transferred" },
    ],
  };
  return flows[status] || flows["Pending Approval"];
};

export const ACTIVITY_LOG = [
  { time: "20 Jul 2026, 10:35 AM", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Submitted", badge: "info", detail: "Claim submitted for approval. 3 items · Subtotal RM 7,992.00 · Cash advance offset RM 0.00." },
  { time: "20 Jul 2026, 10:31 AM", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Amended", badge: "amend", detail: "Changes: Dental filling treatment amount RM 2,650.00 → RM 2,400.00 (corrected against invoice INV-DEN-2981) · Mileage attachment MIL-1121-04 replaced with signed copy." },
  { time: "19 Jul 2026, 5:44 PM", by: "Denny Tan Yee Soon", role: "Head of Unit", action: "Returned", badge: "reject", detail: 'Returned for correction. Reason: "Dental amount does not match the attached invoice, and the mileage form is missing a signature."' },
  { time: "19 Jul 2026, 3:02 PM", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Submitted", badge: "info", detail: "Claim submitted for approval. 3 items · Subtotal RM 8,242.00." },
  { time: "19 Jul 2026, 11:20 AM", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Created", badge: "muted", detail: "Draft created from New Claim · linked to training request TR-2026-062." },
];
